import React from 'react';
import { Button, Dropdown, Checkbox, Space } from 'antd';
import { ColumnHeightOutlined } from '@ant-design/icons';

export interface ColumnConfig {
  title: string;
  key: string;
  visible?: boolean;
}

interface ColumnVisibilityToggleProps {
  columns: ColumnConfig[];
  visibleKeys: React.Key[];
  onChange: (keys: React.Key[]) => void;
  maxVisible?: number;
}

export const ColumnVisibilityToggle: React.FC<ColumnVisibilityToggleProps> = ({
  columns,
  visibleKeys,
  onChange,
  maxVisible,
}) => {
  const selectionLocked = maxVisible !== undefined && visibleKeys.length >= maxVisible;
  return (
    <Dropdown
      trigger={['click']}
      overlayStyle={{
        background: 'white',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        borderRadius: '4px',
      }}
      dropdownRender={() => (
        <div style={{ padding: 12 }}>
          <Checkbox.Group
            value={visibleKeys}
            onChange={(keys) => onChange(keys as React.Key[])}
          >
            <Space direction="vertical">
              {columns.map((col) => (
                <Checkbox
                  key={col.key}
                  value={col.key}
                  disabled={selectionLocked && !visibleKeys.includes(col.key)}
                >
                  <span
                    style={{
                      color:
                        selectionLocked && !visibleKeys.includes(col.key)
                          ? '#9ca3af'
                          : undefined,
                    }}
                  >
                    {col.title}
                  </span>
                </Checkbox>
              ))}
            </Space>
          </Checkbox.Group>
        </div>
      )}
    >
      <Button icon={<ColumnHeightOutlined />}>Columns</Button>
    </Dropdown>
  );
};
